module.exports = __webpack_public_path__ + "c82b613477e7afe7bd336710a0cbbfdc.mp3";


//////////////////
// WEBPACK FOOTER
// ../lib/assets/shared/terug_2.mp3
// module id = 119
// module chunks = 0